import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './dialog';
import { Button } from './button';
import { Input } from './input';
import { AlertTriangle } from 'lucide-react';

const ConfirmDeleteDialog = ({ 
  open, 
  onOpenChange, 
  onConfirm, 
  title = "¿Eliminar?",
  description = "Esta acción no se puede deshacer.",
  itemName = ""
}) => {
  const [confirmText, setConfirmText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (confirmText !== 'ELIMINAR') return;
    
    setLoading(true);
    try {
      await onConfirm();
      setConfirmText('');
      onOpenChange(false);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setConfirmText('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-400">
            <AlertTriangle className="h-5 w-5" />
            {title}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground">
            {description}
            {itemName && (
              <span className="block mt-2 font-semibold text-foreground">
                "{itemName}"
              </span>
            )}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <p className="text-sm text-muted-foreground">
            Para confirmar, escribe <span className="font-bold text-red-400">ELIMINAR</span> en el campo:
          </p>
          <Input
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value.toUpperCase())}
            placeholder="Escribe ELIMINAR"
            className="bg-zinc-900/50 border-zinc-800 text-center font-mono"
            data-testid="confirm-delete-input"
          />
        </div>
        
        <DialogFooter>
          <Button variant="ghost" onClick={handleClose}>
            Cancelar
          </Button>
          <Button 
            variant="destructive"
            onClick={handleConfirm}
            disabled={confirmText !== 'ELIMINAR' || loading}
            data-testid="confirm-delete-button"
          >
            {loading ? 'Eliminando...' : 'Eliminar definitivamente'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { ConfirmDeleteDialog };
